
import React, { useState } from 'react';
import { Dialog, useTheme, Stack, DialogContent, TextField, Box, Grid, Typography } from '@mui/material';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import CustomButton from '../../components/CustomButton';
import { tokens } from "../../theme";
import {
  Timeline,
  TimelineItem,
  timelineItemClasses,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  } from '@mui/lab';
import { useEffect } from 'react';
import { selectedItems } from '../../config/AppConfig';
import { useAtom } from "jotai";
import Pagination from '@mui/material/Pagination';
import { formatPrice } from '../../utils/PriceFormatter';
import { formatInputWithCommas } from '../../utils/PriceFormatter';

function SetCashOutLimitDialog({ 
    open, 
    onClose, 
    onSaveButtonClick ,
    onSaveGlobalButtonClick,
    isGlobalCashOutLimit,
    data , 
    globalData,
    timeline,
    totalNoOfPages,
    onPageChange,
    tiersArray,
    onNewTierSelected,
}) {

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [headerTitle, setHeaderTitle] = useState('Cash Out Limit');
  const [tabs, setTabs] = useState([{label: "Tier 1", value: "Tier 1"}]);
  const [selectedTab, setSelectedTab] = useState(0);    // tab for different tiers
  const [cashOutLimitsNotEditable, setCashOutLimitsNotEditable] = useState(true);

  const [selectedItem, setSelectedItem] = useAtom(selectedItems);
  const [cashOutTimelineDetails, setCashOutTimelineDetails] = useState([]);
  let earmarkInitialValue = ''
  let reasonInitialValue = ''

  const [initialFormData, setInitialFormData] = useState({
    tier: '',
    accountName: '',
    accountCode: '', 
    dailyTransactionCount: '', 
    weeklyTransactionCount: '', 
    monthlyTransactionCount: '', 
    dailyTransactionAmount: '', 
    weeklyTransactionAmount: '', 
    monthlyTransactionAmount: '', 
  });

  const [globalAllTiersData, setGlobalAllTiersData] = useState({});

  const [formData, setFormData] = useState({
    tier: '',
    accountName: '',
    accountCode: '', 
    dailyTransactionCount: '', 
    weeklyTransactionCount: '', 
    monthlyTransactionCount: '', 
    dailyTransactionAmount: '', 
    weeklyTransactionAmount: '', 
    monthlyTransactionAmount: '', 
});
const [errors, setErrors] = useState({});

  // pagination 
  const pageCount = totalNoOfPages ? totalNoOfPages : 1;
  const [currentPage, setCurrentPage] = useState(1);
  const handlePageChange = (value) => {
    setCurrentPage(value);
    onPageChange(value-1); // Index starts from 0 for data array
};

useEffect(() => {
    setSelectedTab(tabs[0]?.value);     // set first tab (tier 1) to be selected by default
}, []);

useEffect(() => {
    const formattedTiers = tiersArray.map(tier => ({ 
        label: tier, 
        value: tier, 
        disabled: true
    }));
    setTabs(formattedTiers);
}, [tiersArray]);

// set data when open / close dialog
useEffect(() => {
    if (globalData){
        setGlobalAllTiersData(globalData);
    }

    // for the case of non-global cash out limit
    if(data && !isGlobalCashOutLimit) {
        const formattedTiers = tiersArray.map(tier => ({ 
            label: tier, 
            value: tier, 
            disabled: false
            // disabled: (data.tier === tier ? false : true)
        }));
        setTabs(formattedTiers);
        setSelectedTab(data.tier);

        const value = {
            accountName: data.accountName,
            tier: data.tier,
            accountCode: data.accountCode, 
            dailyTransactionCount: data.dailyTransactionCount, 
            weeklyTransactionCount: data.weeklyTransactionCount, 
            monthlyTransactionCount: data.monthlyTransactionCount, 
            dailyTransactionAmount: data.dailyTransactionAmount, 
            weeklyTransactionAmount: data.weeklyTransactionAmount, 
            monthlyTransactionAmount: data.monthlyTransactionAmount, 
        }
        setFormData(value)
        setInitialFormData(value); // Set initial form data
        setCashOutLimitsNotEditable(false); // by default when it first opens, the cash out limits are editable
    }

    if (globalData && isGlobalCashOutLimit && globalData.length > 0) {
        try {
            // set global data to be used for saving
        // create formattedTiers, where only the values found in each item.tier in globalData will be in, the rest will not be in the array
        const formattedTiersArray = globalData.map(item => ({
            label: item.tier,
            value: item.tier,
            disabled: false
        }));
        setTabs(formattedTiersArray);

        setInitialFormData(globalData);

        if (formattedTiersArray.length > 0 && selectedTab) {
            var validSelectedTab = globalData.find(item => item === selectedTab) ? selectedTab : formattedTiersArray[0].value;
            setSelectedTab(validSelectedTab);
            const selectedTierData = globalData.find(item => item.tier === validSelectedTab);
            const formattedSelectedTierData = {
                ...selectedTierData,
                dailyTransactionAmount: (selectedTierData.dailyTransactionAmount),
                weeklyTransactionAmount: (selectedTierData.weeklyTransactionAmount),
                monthlyTransactionAmount: (selectedTierData.monthlyTransactionAmount),
            };
            setFormData(formattedSelectedTierData);
            if (open) {
                onNewTierSelected(validSelectedTab);
            }

        } else if (formattedTiersArray.length > 0){
            setSelectedTab(formattedTiersArray[0].value);
            const selectedTierData = globalData.find(item => item.tier === formattedTiersArray[0].value);
            setFormData(selectedTierData);
            if (open){
                onNewTierSelected(formattedTiersArray[0].value);
            }
        }
    } catch (error) {
        console.error('Error setting global data: ', error);
    }
    }

    clearErrors();
    
}, [open, data, globalData]);

useEffect(() => {
    if(timeline) {
        setCashOutTimelineDetails(timeline)
    }
}, [timeline]);
  

  useEffect(() => {
    if (isGlobalCashOutLimit){
        setHeaderTitle('Global Cash Out Limit');
        
    } else {
        setHeaderTitle('Cash Out Limit');
    }
}, [isGlobalCashOutLimit]);


  const handleInputChange = (e) => {
    const {  name, value } = e.target;
    const sanitizedValue = value.replace(/,/g, '');
    setFormData({ ...formData, [name]: sanitizedValue });
    setErrors({ ...errors, [name]: '' });
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);

    if (isGlobalCashOutLimit) {
        // set new tier for parent component to call API and update timeline details
        onNewTierSelected(newValue);

        // change form data to the respective tier's data. The original data structure looks as below:
    //     "result": {
    //         "cashOutLimitDetailPage": {
    //             "content": [
    //                 {
    //                     "accountName": "GLOBAL",
    //                     "accountCode": "ALL",
    //                     "vendorCode": "NA",
    //                     "tier": "Tier 1",
    //                     "dailyTransactionCount": 2,
    //                     "weeklyTransactionCount": 4,
    //                     "monthlyTransactionCount": 10,
    //                     "dailyTransactionAmount": 10000.00,
    //                     "weeklyTransactionAmount": 20000.00,
    //                     "monthlyTransactionAmount": 40000.00
    //                 },
    //                 {
    //                     "accountName": "GLOBAL",
    //                     "accountCode": "ALL",
    //                     "vendorCode": "NA",
    //                     "tier": "Tier 2",
    //                     "dailyTransactionCount": 2,
    //                     "weeklyTransactionCount": 4,
    //                     "monthlyTransactionCount": 10,
    //                     "dailyTransactionAmount": 25000.00,
    //                     "weeklyTransactionAmount": 50000.00,
    //                     "monthlyTransactionAmount": 100000.00
    //                 },
    //                 {
    //                     "accountName": "GLOBAL",
    //                     "accountCode": "ALL",
    //                     "vendorCode": "NA",
    //                     "tier": "Tier 3",
    //                     "dailyTransactionCount": 2,
    //                     "weeklyTransactionCount": 4,
    //                     "monthlyTransactionCount": 10,
    //                     "dailyTransactionAmount": 50000.00,
    //                     "weeklyTransactionAmount": 100000.00,
    //                     "monthlyTransactionAmount": 150000.00
    //                 }
    //             ],
    //             "totalPages": 1,
    //             "totalElements": 3,
    //             "last": true,
    //             "size": 0,
    //             "number": 0,
    //             "sort": null,
    //             "first": true,
    //             "numberOfElements": 3
    //         },
    //         "sortColumns": null
    //     }

        // save the global data first before switching
        if (selectedTab) {
            setGlobalAllTiersData(prevState => {
                const updatedData = prevState.map(item => {
                    if (item.tier === selectedTab) {
                        return {
                            ...item,
                            accountName: formData.accountName,
                            accountCode: formData.accountCode,
                            dailyTransactionCount: formData.dailyTransactionCount,
                            weeklyTransactionCount: formData.weeklyTransactionCount,
                            monthlyTransactionCount: formData.monthlyTransactionCount,
                            dailyTransactionAmount: formData.dailyTransactionAmount,
                            weeklyTransactionAmount: formData.weeklyTransactionAmount,
                            monthlyTransactionAmount: formData.monthlyTransactionAmount,
                        }
                    }
                    return item;
                });
                return updatedData;
            });
            
            // search for the selected tier's data
            const selectedTierData = globalAllTiersData.find(item => item.tier === newValue);
            setFormData(selectedTierData);
        }
    } else {    // for non-global cash out limit
        if (newValue === "Customized" || newValue === initialFormData.tier) {
            const updatedData = {
                ...initialFormData,
                tier: newValue,
            };
            setFormData(updatedData);
            setCashOutLimitsNotEditable(false);
        } else {
            // search for the selected tier's data
            const selectedTierData = globalAllTiersData.find(item => item.tier === newValue);
            const updatedData = {
                ...selectedTierData,
                accountName: formData.accountName,
                accountCode: formData.accountCode,
            };
            setFormData(updatedData);
            setCashOutLimitsNotEditable(true);
        }
    }
  };


const handleSave = (e) => {
 
    e.preventDefault();

    // Check if formData is the same as initialFormData
    if (JSON.stringify(formData) === JSON.stringify(initialFormData)) {
        alert('Cannot submit the same data as before. Please make changes to the form.');
        return;
    }

    const newErrors = validateFormData();

    if (Object.keys(newErrors).length === 0) {
      // Form is valid, submit the data
     

      if (isGlobalCashOutLimit) {

        // save global data with the latest formData and then pass to onSaveGlobalButtonClick
        const updatedGlobalData = globalAllTiersData.map(item => {
            if (item.tier === selectedTab) {
                return {
                    ...item,
                    accountName: formData.accountName,
                    accountCode: formData.accountCode,
                    dailyTransactionCount: formData.dailyTransactionCount,
                    weeklyTransactionCount: formData.weeklyTransactionCount,
                    monthlyTransactionCount: formData.monthlyTransactionCount,
                    dailyTransactionAmount: formData.dailyTransactionAmount,
                    weeklyTransactionAmount: formData.weeklyTransactionAmount,
                    monthlyTransactionAmount: formData.monthlyTransactionAmount,
                }
            }
            return item;
        });

        // check if all required fields are filled in every tier saved in globalAllTiersData
        const requiredFields = ['dailyTransactionCount', 'weeklyTransactionCount', 'monthlyTransactionCount', 'dailyTransactionAmount', 'weeklyTransactionAmount', 'monthlyTransactionAmount'];
        let isAllFieldsFilled = true;

        for (const item of updatedGlobalData) {
            if (item.tier === selectedTab){
                continue;
            }

            for (const field of requiredFields) {
                if (item[field] === '' || item[field] === null) {
                    isAllFieldsFilled = false;
                    break;
                }
            }
            if (!isAllFieldsFilled) {
                break;
            }
        }

        if (!isAllFieldsFilled) {
            alert('Please fill in all required fields for all tiers before saving.');
            return;
        }


        onSaveGlobalButtonClick(updatedGlobalData);
        onClose();  // close the dialog

      } else {
        onSaveButtonClick(formData);
        onClose();
      }

    } else {
      // Form is not valid, update the errors state
      setErrors(newErrors);
    }
  };

  function validateFormData() {
      const newErrors = {};

    // Helper function to validate transaction count to ensure only whole numbers are entered
    const validateTransactionCount = (value, fieldName) => {
        if (value === undefined || value === null || value <= 0) {
            newErrors[fieldName] = `Transaction count must be greater than 0`;
        } else {
            const isValidCount = /^\d+$/.test(formData[fieldName]);
            if (!isValidCount) {
                newErrors[fieldName] = 'Count must be a whole number';
            }
        }
    };

    // helper function to validate amount fields
    const validateTransactionAmount = (value, fieldName) => {
        if (value === undefined || value === null || value <= 0) {
            newErrors[fieldName] = `Amount must be greater than 0`;
        } else {
            const isValidAmount = /^\d+(\.\d{1,2})?$/.test(value);
            if (!isValidAmount) {
                newErrors[fieldName] = 'Amount must be a number with up to 2 decimal places';
            }
        }
    }

    // Validate transaction counts and amounts
    validateTransactionCount(formData.dailyTransactionCount, 'dailyTransactionCount');
    validateTransactionCount(formData.weeklyTransactionCount, 'weeklyTransactionCount');
    validateTransactionCount(formData.monthlyTransactionCount, 'monthlyTransactionCount');

    validateTransactionAmount(formData.dailyTransactionAmount, 'dailyTransactionAmount');
    validateTransactionAmount(formData.weeklyTransactionAmount, 'weeklyTransactionAmount');
    validateTransactionAmount(formData.monthlyTransactionAmount, 'monthlyTransactionAmount');

      return newErrors;
  }

  const clearErrors = () => {
    setErrors({});
    };

  return (
      <Dialog open={open} onClose={onClose} PaperProps={{ sx: { borderRadius: "12px", background:"transparent", boxShadow:"none" } }}>
        
        <DialogContent sx={{ background:"white", borderRadius:"12px", overflow: "initial", marginBottom:"15px" }}>
            <Grid container direction={'column'}>
                <Grid container justifyContent="center" pb={2}>
                      <Grid
                          container
                          justifyContent="center"
                          alignItems="center"
                      >
                          <Typography fontWeight={'600'} variant="h3" p={1}>
                              {headerTitle}
                          </Typography>
                      </Grid>

                        {/* Tabs for Tier */}
                        <Grid item>
                            <Tabs 
                                value={selectedTab} 
                                onChange={handleTabChange} 
                                aria-label="cash out limit tabs"
                                variant="fullWidth"
                                >
                                    {tabs.map((tab, index) => (
                                        <Tab 
                                            label={tab.label} 
                                            value={tab.value} 
                                            key={index} 
                                            disabled={ isGlobalCashOutLimit? false : tab.disabled} />
                                    ))}
                            </Tabs>
                        </Grid>

                </Grid>

                <form>
                      <Grid container direction={'column'}>

                            { !isGlobalCashOutLimit &&
                            <Grid
                                container
                                item
                                xs={12}
                                alignItems={'center'}
                                spacing={3}
                                pb={1}
                            >
                                <Grid item xs={3}>
                                    <Typography
                                        color={colors.grey[100]}
                                        fontWeight={'500'}
                                        variant="h6"
                                        sx={{ textAlign: 'left' }}
                                    >
                                        Dealer
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <TextField
                                        margin="dense"
                                        type="text"
                                        name="accountName"
                                        fullWidth
                                        value={formData.accountName}
                                        // disabled
                                        contentEditable={false}
                                        // onChange={handleInputChange}
                                        // error={Boolean(errors.earmark)}
                                        // helperText={errors.earmark}
                                    />
                                </Grid>
                            </Grid>}

                            <Grid container spacing={1} pb={1} >
                                {/* Daily Limit Row */}
                                <Grid item xs={3} container alignItems="center">
                                    <Typography color={colors.grey[100]} fontWeight="500" variant="h6" style={{ textAlign: 'right' }}>
                                    Daily Limit
                                    </Typography>
                                </Grid>
                                <Grid item xs={5} container alignItems="center">
                                    <TextField
                                    margin="dense"
                                    label="Daily Transaction Limit (RM)"
                                    type="text"
                                    name="dailyTransactionAmount"
                                    fullWidth
                                    value={formatInputWithCommas(formData.dailyTransactionAmount)}
                                    onChange={handleInputChange}
                                    error={Boolean(errors.dailyTransactionAmount)}
                                    helperText={errors.dailyTransactionAmount}
                                    disabled={cashOutLimitsNotEditable}
                                    />
                                </Grid>
                                <Grid item xs={4} container alignItems="center">
                                    <TextField
                                    fullWidth
                                    margin="dense"
                                    label="Transaction Count"
                                    type="number"
                                    name="dailyTransactionCount"
                                    value={formData.dailyTransactionCount}
                                    onChange={handleInputChange}
                                    error={Boolean(errors.dailyTransactionCount)}
                                    helperText={errors.dailyTransactionCount}
                                    disabled={cashOutLimitsNotEditable}
                                    >
                                    {/* Dropdown options here */}
                                    </TextField>
                                </Grid>

                                {/* Weekly Limit Row */}
                                <Grid item xs={3} container alignItems="center">
                                    <Typography color={colors.grey[100]} fontWeight="500" variant="h6" style={{ textAlign: 'right' }}>
                                    Weekly Limit
                                    </Typography>
                                </Grid>
                                <Grid item xs={5} container alignItems="center">
                                    <TextField
                                    margin="dense"
                                    label="Weekly Transaction Limit (RM)"
                                    type="text"
                                    name="weeklyTransactionAmount"
                                    fullWidth
                                    value={formatInputWithCommas(formData.weeklyTransactionAmount)}
                                    onChange={handleInputChange}
                                    error={Boolean(errors.weeklyTransactionAmount)}
                                    helperText={errors.weeklyTransactionAmount}
                                    disabled={cashOutLimitsNotEditable}
                                    />
                                </Grid>
                                <Grid item xs={4} container alignItems="center">
                                    <TextField
                                    fullWidth
                                    margin="dense"
                                    label="Transaction Count"
                                    type="number"
                                    name="weeklyTransactionCount"
                                    value={formData.weeklyTransactionCount}
                                    onChange={handleInputChange}
                                    error={Boolean(errors.weeklyTransactionCount)}
                                    helperText={errors.weeklyTransactionCount}
                                    disabled={cashOutLimitsNotEditable}
                                    >
                                    {/* Dropdown options here */}
                                    </TextField>
                                </Grid>

                                {/* Monthly Limit Row */}
                                <Grid item xs={3} container alignItems="center">
                                    <Typography color={colors.grey[100]} fontWeight="500" variant="h6" style={{ textAlign: 'right' }}>
                                    Monthly Limit
                                    </Typography>
                                </Grid>
                                <Grid item xs={5} container alignItems="center">
                                    <TextField
                                    margin="dense"
                                    label="Monthly Transaction Limit (RM)"
                                    type="text"
                                    name="monthlyTransactionAmount"
                                    fullWidth
                                    value={formatInputWithCommas(formData.monthlyTransactionAmount)}
                                    onChange={handleInputChange}
                                    error={Boolean(errors.monthlyTransactionAmount)}
                                    helperText={errors.monthlyTransactionAmount}
                                    disabled={cashOutLimitsNotEditable}
                                    />
                                </Grid>
                                <Grid item xs={4} container alignItems="center">
                                    <TextField
                                    fullWidth
                                    margin="dense"
                                    label="Transaction Count"
                                    type="number"
                                    name="monthlyTransactionCount"
                                    value={formData.monthlyTransactionCount}
                                    onChange={handleInputChange}
                                    error={Boolean(errors.monthlyTransactionCount)}
                                    helperText={errors.monthlyTransactionCount}
                                    disabled={cashOutLimitsNotEditable}
                                    >
                                    {/* Dropdown options here */}
                                    </TextField>
                                </Grid>
                            </Grid>

                          <Stack
                              direction="row"
                              pt={2}
                              spacing={2}
                              justifyContent={'center'}
                          >

                            <CustomButton
                                  btnBG={colors.primary[900]}
                                  btnColor={colors.grey[100]}
                                  btnTxt={'Close'}
                                  btnBorder={'1px solid' + colors.primary[800]}
                                  onClick={onClose}
                              ></CustomButton>

                              <CustomButton
                                  btnBG={colors.primary[100]}
                                  btnColor={colors.grey[900]}
                                  btnTxt={'Save'}
                                  btnBorder={'1px solid' + colors.primary[100]}
                                  onClick={handleSave}
                              ></CustomButton>
                          </Stack>
                      </Grid>
                </form>
            </Grid>
        </DialogContent>

          <DialogContent sx={{ background:"white", borderRadius:"12px" }}>
              <Grid container direction={'column'}>
                  

                  <Grid container item xs={12}>
                    <Grid container justifyContent="space-between" alignItems="center" sx={{ marginTop: 1 }}>
                        <Typography 
                            fontSize={20}
                            fontWeight={700}
                            xs={6}>Timeline</Typography>
                        <Pagination
                            xs={6}
                            count={pageCount}
                            page={currentPage}
                            onChange={(event, value) => handlePageChange(value)}
                        />
                    </Grid>

                              <Grid
                                  item
                                  xs={12}
                                  justifyitem={'flex-start'}
                                  alignitem={'flex-start'}
                              >
                                  {cashOutTimelineDetails.length > 0 ? (
                                      <Timeline
                                          sx={{
                                              [`& .${timelineItemClasses.root}:before`]:
                                                  {
                                                      flex: 0,
                                                      padding: 0,
                                                  },
                                          }}
                                      >
                                          {cashOutTimelineDetails.map((row, index) => (
                                              <TimelineItem key={row.id}>
                                                  <TimelineSeparator>
                                                      <TimelineDot
                                                          sx={{
                                                              background: (currentPage===1 && index === 0) ? colors.primary[100] : colors.primary[700],
                                                              width: '14px',
                                                              height: '14px',
                                                              marginTop: '70%',
                                                          }}
                                                      />
                                                      {index !== cashOutTimelineDetails.length - 1 && (
                                                      <TimelineConnector
                                                          sx={{
                                                              background: colors.primary[700],
                                                              width: '1px',
                                                          }}
                                                      />
                                                      )}
                                                  </TimelineSeparator>

                                                  <TimelineContent>
                                                    <Box sx={{ display: 'flex', flexDirection: 'column'}}>

                                                    {row.dailyTransactionAmount && row.dailyTransactionCount && (
                                                        <Box sx={{ display: 'flex', flexWrap: 'nowrap' }}>
                                                            <Typography fontWeight={'600'} marginRight={'8px'}>
                                                                <span>RM {formatPrice(row.dailyTransactionAmount)} / {row.dailyTransactionCount}X</span>
                                                            </Typography>
                                                            <Typography fontWeight={'400'}>
                                                                <span>&nbsp;&nbsp;Daily Limit&nbsp;&nbsp;&nbsp;{row.operation}</span>
                                                            </Typography>
                                                        </Box>
                                                    )}

                                                    {row.weeklyTransactionAmount && row.weeklyTransactionCount && (
                                                        <Box sx={{ display: 'flex', flexWrap: 'nowrap' }}>
                                                            <Typography fontWeight={'600'} marginRight={'8px'}>
                                                                <span>RM {formatPrice(row.weeklyTransactionAmount)} / {row.weeklyTransactionCount}X</span>
                                                            </Typography>
                                                            <Typography fontWeight={'400'}>
                                                                <span>&nbsp;&nbsp;Weekly Limit&nbsp;&nbsp;&nbsp;{row.operation}</span>
                                                            </Typography>
                                                        </Box>
                                                    )}

                                                    {row.monthlyTransactionAmount && row.monthlyTransactionCount && (
                                                        <Box sx={{ display: 'flex', flexWrap: 'nowrap' }}>
                                                            <Typography fontWeight={'600'} marginRight={'8px'}>
                                                                <span>RM {formatPrice(row.monthlyTransactionAmount)} / {row.monthlyTransactionCount}X</span>
                                                            </Typography>
                                                            <Typography fontWeight={'400'}>
                                                                <span>&nbsp;&nbsp;Monthly Limit&nbsp;&nbsp;&nbsp;{row.operation}</span>
                                                            </Typography>
                                                        </Box>
                                                    )}
                                                    <Typography color={colors.grey[300]} fontSize={'0.8rem'}>
                                                        {row.operationDate}
                                                    </Typography>
                                                    </Box>
                                                 </TimelineContent>
                                              </TimelineItem>
                                          ))}
                                      </Timeline>
                                  ) : (
                                      ''
                                  )}
                              </Grid>

                              {/* <Grid item fontSize={20} fontWeight={700} xs={6}>Date Time</Grid> */}

                              <Grid item></Grid>
                          </Grid>
              </Grid>
          </DialogContent>
          {/* <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button  variant="contained" type="submit" onClick={handleSubmit} color="primary">
          Submit
        </Button>
      </DialogActions> */}
      </Dialog>
  );
}

export default SetCashOutLimitDialog;
